import { ArrowLeft, ChevronRight } from "lucide-react";
import SaveDraftButton from "../../../components/SaveDraftButton";
import {
  FormStack,
  PropertyStepActions,
} from "../../../components/propertyDescription/descriptionUi";
import {
  NextButton,
  RegisterButton,
} from "../../CreateProperty/twStyles";
import { PublishOnImovelWebButton } from "../twStyles";
import { useEditPropertyWizard } from "./EditPropertyWizardContext";
import ResponsiblesSection from "./description/ResponsiblesSection";
import PublicationSection from "./description/PublicationSection";

export default function EditPublicationStep() {
  const {
    handleGoToCharacteristicForm,
    handlePublishOnImovelWeb,
    handleSaveDraft,
    handleDraftNextFromPublication,
    handleShareLink,
    isDraft,
    isSavingDraft,
    loadingRequest,
    loadingSharedLink,
    setFormOptionSelected,
  } = useEditPropertyWizard();

  return (
    <div className="w-full min-w-0">
      <FormStack>
        <ResponsiblesSection />
        <PublicationSection />
      </FormStack>

      <PropertyStepActions
        leading={
          <>
            {isDraft ? (
              <SaveDraftButton isLoading={isSavingDraft} onClick={handleSaveDraft} />
            ) : (
              <RegisterButton
                type="button"
                className="h-10 py-0"
                onClick={loadingRequest ? () => {} : handleGoToCharacteristicForm}
              >
                <p>{loadingRequest ? "Carregando..." : "Salvar"}</p>
              </RegisterButton>
            )}
            <PublishOnImovelWebButton
              type="button"
              className="h-10 py-0"
              onClick={handlePublishOnImovelWeb}
            >
              <p>Publicar no Imóvel Web</p>
            </PublishOnImovelWebButton>
            <PublishOnImovelWebButton
              type="button"
              className="h-10 py-0"
              onClick={handleShareLink}
            >
              <p>{loadingSharedLink ? "Gerando link..." : "Gerar link"}</p>
            </PublishOnImovelWebButton>
          </>
        }
        trailing={
          <>
            <NextButton
              type="button"
              className="inline-flex h-10 gap-1.5 py-0 [&>svg]:!ml-0"
              onClick={() => {
                setFormOptionSelected("description");
                window.scrollTo(0, 0);
              }}
            >
              <ArrowLeft className="h-4 w-4 text-white" aria-hidden />
              <p>Voltar</p>
            </NextButton>
            <NextButton
              type="button"
              className="inline-flex h-10 gap-1.5 py-0"
              onClick={() => {
                if (isDraft) {
                  handleDraftNextFromPublication?.();
                  return;
                }
                setFormOptionSelected("characteristic");
                window.scrollTo(0, 0);
              }}
            >
              <p>Próximo</p>
              <ChevronRight className="h-4 w-4 text-white" aria-hidden />
            </NextButton>
          </>
        }
      />
    </div>
  );
}
